/* eslint-disable indent */
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, Inject } from "@angular/core";
import {
  FinSimulacaoFinanciadoraStatus,
  FinSimulacaoOrigem,
  StatusTarefa,
  TipoArquivo,
  TipoVerificacaoImagem
} from "../../../models/enum";
import { GiFinSimulacaoFinanciadoraModel } from "../../../dominio/gi-fin-simulacao-financiadora-model";
import { NotificacaoService } from "../../../services/notificacao.service";
import { FinSimulacaoService } from "../../../services/fin-simulacao.service";
import { ArquivoService } from "../../../services/arquivo.service";
import { UtilitarioService } from "../../../services/utilitario.service";
import { CarregandoService } from "../../../services/carregando.service";
import { CommonFinanceModel } from "../../models/common-finance-model";
import { FilaTarefa } from "src/app/models/filas/fila-tarefa";
import { QueryFilterService } from "../../../core/services/query-filter-service";
import { GiFinSituacaoModel } from "../../../dominio/gi-fin-situacao-model";
import { AtribuicaoModalComponent } from "../../modals/atribuicao-modal/atribuicao-modal.component";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import {
  AlterarSituacaoFinanciadoraModalComponent
} from "../../modals/alterar-situacao-financiadora-modal/alterar-situacao-financiadora-modal.component";

@Component({
  selector: "app-financiadoras",
  templateUrl: "./financiadoras.component.html",
  styleUrls: ["./financiadoras.component.scss"],
})
export class FinanciadorasComponent implements OnInit, OnDestroy {
  @Input() idSimulacao?: number | null;
  @Input() tarefa?: FilaTarefa | null;
  @Output() onChange = new EventEmitter<CommonFinanceModel>();

  financiadorasSimulacao?: GiFinSimulacaoFinanciadoraModel[] = [];
  financiadoraSelecionada: number = null;
  podeEditar = false;
  commom: CommonFinanceModel = new CommonFinanceModel();

  intervaloBuscaFinanciadora;

  constructor(
    private notificacaoService: NotificacaoService,
    private finSimulacaoService: FinSimulacaoService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private queryFilterService: QueryFilterService,
    public dialog: MatDialog,
  ) { }

  async ngOnInit() {
    await this.buscarFinanciadoras();

    this.intervaloBuscaFinanciadora = setInterval(() => {
      this.reloadFinanciadoras();
    }, 5000);

    if (this.tarefa !== null && this.tarefa !== undefined) {
      switch (this.tarefa.status) {
        case StatusTarefa.Iniciada:
        case StatusTarefa.Retomada:
          this.podeEditar = true;
          break;

        default:
          this.podeEditar = false;
          break;
      }
    }
  }

  ngOnDestroy() {
    clearInterval(this.intervaloBuscaFinanciadora);
  }

  async buscarFinanciadoras() {
    this.carregandoService.mostra("buscaFinanciadoras");

    (this.tarefa !== null && this.tarefa !== undefined
      ? this.finSimulacaoService.buscarFinanciadorasPorTarefa(this.tarefa.id)
      : this.finSimulacaoService.buscarFinanciadoras(this.idSimulacao)
    ).subscribe(
      async (data) => {
        this.financiadorasSimulacao = data.results;

        await Promise.all(this.financiadorasSimulacao.map((f) => this.buscarImagemFinanciadora(f.financiadora.id)));

        if (this.financiadorasSimulacao.length > 0) {
          for (const f of this.financiadorasSimulacao) {
            await this.buscarSumarioFinanciadora(f);
          }

          if (this.financiadorasSimulacao[0].sumario) {
            this.selecionarFinanciadora(this.financiadorasSimulacao[0].id);
          }
        }

        this.carregandoService.esconde("buscaFinanciadoras");
      },
      (erro) => {
        this.carregandoService.esconde("buscaFinanciadoras");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarSumarioFinanciadora(financiadora: GiFinSimulacaoFinanciadoraModel) {
    // this.carregandoService.mostra("buscaSumarioFinanciadora");

    const service = this.tarefa !== null && this.tarefa !== undefined
      ? this.finSimulacaoService.buscaSumarioFinanciadoraCelulaCredito(this.tarefa.id, financiadora.id)
      : this.finSimulacaoService.buscaSumarioFinanciadoraMeuFinanciamento(this.idSimulacao, financiadora.id);

    service.subscribe(
      (data) => {
        financiadora.sumario = data.result;

        this.commom.expirou = financiadora.sumario.expirado;
        // this.onChange.emit(this.commom);
        // this.carregandoService.esconde("buscaSumarioFinanciadora");
      }, (erro) => {
        // this.carregandoService.esconde("buscaSumarioFinanciadora");
        this.notificacaoService.erro(erro);
      }
    );
  }

  selecionarFinanciadora(idVinculo: number): void {
    if (idVinculo === this.financiadoraSelecionada) {
      this.financiadoraSelecionada = null;
      const commom = new CommonFinanceModel();
      commom.limparDados = true;
      commom.idFinanciadora = null;
      this.onChange.emit(commom);
      return;
    }

    this.financiadoraSelecionada = idVinculo;

    const financiadoraEncontrada = this.financiadorasSimulacao.find((f) => f.id === idVinculo);

    this.commom = {
      idFinanciadora: financiadoraEncontrada.financiadora.id,
      idVinculo: financiadoraEncontrada.id,
      nomeFinanciadora:
        financiadoraEncontrada.financiadora.nome != null ? financiadoraEncontrada.financiadora.nome : "",
      statusFinSimulacao: financiadoraEncontrada.status,
      financiadora: financiadoraEncontrada.financiadora,
      imagem$: financiadoraEncontrada.financiadora.imagem$,
      buscouImagem: financiadoraEncontrada.financiadora.buscouImagem,
      semImagem: financiadoraEncontrada.financiadora.semImagem,
      limparDados: false,
      statusMsg: financiadoraEncontrada.statusMsg,
      expirou: financiadoraEncontrada.sumario.expirado,
    };

    this.onChange.emit(this.commom);
  }

  async reloadFinanciadoras(carregando: boolean = false) {
    if (carregando) {
      this.carregandoService.mostra("buscaReloadFinanciadoras");
    }

    (this.tarefa !== null && this.tarefa !== undefined
      ? this.finSimulacaoService.buscarFinanciadorasPorTarefa(this.tarefa.id)
      : this.finSimulacaoService.buscarFinanciadoras(this.idSimulacao)
    ).subscribe(
      async (data) => {
        const financiadoras = data.results;

        if (financiadoras.length > 0) {
          financiadoras.forEach((f) => {
            this.buscarSumarioFinanciadora(f);
          });
        }

        const houveAlteracao = this.financiadorasSimulacaoForamAlteradas(financiadoras);

        if (houveAlteracao) {
          const imagensParaBuscar = financiadoras
            .filter((f) => {
              const existente = this.financiadorasSimulacao.find((e) => e.id === f.id);
              return !existente;
            })
            .map((f) => f.financiadora.id);

          // Preserva imagens já carregadas
          financiadoras.forEach((f) => {
            const existente = this.financiadorasSimulacao.find((e) => e.id === f.id);
            if (existente != null && existente.financiadora) {
              f.financiadora.imagem$ = existente.financiadora.imagem$;
              f.financiadora.buscouImagem = existente.financiadora.buscouImagem;
              f.financiadora.semImagem = existente.financiadora.semImagem;
            }
          });

          this.financiadorasSimulacao = financiadoras;

          await Promise.all(imagensParaBuscar.map((id) => this.buscarImagemFinanciadora(id)));

          // Atualiza o emit caso a financiadora selecionada tenha mudado de status
          if (this.financiadoraSelecionada) {
            const financiadoraAtualizada = this.financiadorasSimulacao.find(
              (f) => f.id === this.financiadoraSelecionada
            );
            if (financiadoraAtualizada) {
              this.selecionarFinanciadora(financiadoraAtualizada.id);
            }
          }
        }

        this.carregandoService.esconde("buscaReloadFinanciadoras");
      },
      (erro) => {
        this.carregandoService.esconde("buscaReloadFinanciadoras");
        this.notificacaoService.erro(erro);
      }
    );
  }

  private financiadorasSimulacaoForamAlteradas(novasFinanciadoras: GiFinSimulacaoFinanciadoraModel[]): boolean {
    if (novasFinanciadoras.length !== this.financiadorasSimulacao.length) {
      return true;
    }

    return novasFinanciadoras.some((nova) => {
      const existente = this.financiadorasSimulacao.find((e) => e.id === nova.id);
      return !existente || existente.status !== nova.status || existente.visivel !== nova.visivel;
    });
  }

  async buscarImagemFinanciadora(idFinanciadora: number): Promise<void> {
    try {
      const financiadoraEncontrada = this.financiadorasSimulacao.find((f) => f.financiadora.id === idFinanciadora);

      const financiadoraExistente = financiadoraEncontrada ? financiadoraEncontrada.financiadora : null;

      if (!financiadoraExistente) return;

      financiadoraExistente.imagem$ = this.arquivoService
        .baixarArquivo(idFinanciadora, TipoArquivo.FinanciadoraImagem)
        .map((m) => this.utilitarioService.toBase64ComInicio(m))
        .toPromise();

      await financiadoraExistente.imagem$
        .then(() => {
          financiadoraExistente.buscouImagem = true;
        })
        .catch(() => {
          financiadoraExistente.semImagem = true;
        });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  verificaImagem(idFinanciadora: number, tipoVerificacao: TipoVerificacaoImagem | number): boolean {
    if (!idFinanciadora) return false;

    const financiadoraSimulacao = this.financiadorasSimulacao.find(
      (p) => p.financiadora.id === idFinanciadora
    ).financiadora;

    if (!financiadoraSimulacao) return false;

    switch (tipoVerificacao) {
      case TipoVerificacaoImagem.SemImagem:
        return !!financiadoraSimulacao.semImagem;
      case TipoVerificacaoImagem.BuscouImagem:
        return !!financiadoraSimulacao.buscouImagem;
      case TipoVerificacaoImagem.RecuperarImagem:
        return !!financiadoraSimulacao.imagem$;
      default:
        return false;
    }
  }

  buscaImagem(idFinanciadora: number) {
    const financiadoraSimulacao = this.financiadorasSimulacao.find(
      (p) => p.financiadora.id === idFinanciadora
    ).financiadora;

    if (!financiadoraSimulacao) return "";
    return financiadoraSimulacao.imagem$;
  }

  retornaStatusFinanciadora(simulacao: GiFinSimulacaoFinanciadoraModel): string {
    switch (simulacao.status) {
      case 0:
        return "Pronta pra enviar";
      case 1:
        return "Enviada";
      case 2:
        return "Aprovada";
      case 3:
        return "Reprovada";
      case 4:
        return "Solicitada";
      case 5:
        return "Em processamento";
      case 6:
        return "Indisponível";
      case 19:
        return "Concluído";
      case 20:
        return "Erro de configuração";
      case 21:
        return "Erro de validação";
      case 29:
        return "Erro crítico";
      default:
        return "";
    }
  }

  retornaClasseBadgeStatus(status: FinSimulacaoFinanciadoraStatus): string {
    switch (status) {
      case 2:
        return "badge badge-pill badge-info";
      case 3:
        return "badge badge-pill badge-danger";
      default:
        return "badge badge-pill badge-warning";
    }
  }

  alterarVisibilidadeFinanciadora(vinculo: GiFinSimulacaoFinanciadoraModel, visivel: boolean) {
    this.carregandoService.mostra("alterarVisibilidadeFinanciadora");

    this.finSimulacaoService.alterarVisibilidadeFinanciadora(this.tarefa.id, vinculo.id, visivel).subscribe(
      (resultado) => {
        vinculo.visivel = visivel;
        this.carregandoService.esconde("alterarVisibilidadeFinanciadora");
      },
      (erro) => {
        this.carregandoService.esconde("alterarVisibilidadeFinanciadora");
        this.notificacaoService.erro(erro);
      }
    );
  }

  async atualizarFinanciadoras() {
    await this.buscarFinanciadoras();
  }

  alterarSituacaoFinanciadora(finSimulacao: GiFinSimulacaoFinanciadoraModel) {
    const dialogRef = this.dialog.open(AlterarSituacaoFinanciadoraModalComponent, {
      width: "700px",
      data: {
        finSimulacao: finSimulacao,
        idTarefa: this.tarefa.id
      },
      panelClass: ["modal-card", "modal-card-v2"],
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        this.atualizarFinanciadoras().then();
      }
    });
  }

  public readonly TipoVerificacaoImagem = TipoVerificacaoImagem;
  protected readonly FinSimulacaoOrigem = FinSimulacaoOrigem;
}
